import { getOr } from 'lodash/fp';

export const getOrZero = getOr(0);
